/* eslint-disable react-hooks/exhaustive-deps */
import { Modal, message, Select, Typography, Checkbox } from 'antd';
import { useEffect, useState } from 'react';
import API from '../../../services/API';
import LoaderComponent from '../../Loader';

const { Option } = Select;
const { Text } = Typography;


function SilaPaymentModal({ silaModalVisible, closeSilaModal, userId, productId, paymentProductType, refreshList }) {
  
  const [visible, setVisible] = useState(false);
  const [modalLoading, showModalLoading] = useState(false);
  const [plaidAccounts, setPlaidAccounts] = useState([]);
  const [selectedPlaidId, setSelectedPlaidId] = useState(null);
  const [loadingPlaidAccounts, setLoadingPlaidAccounts] = useState(false);
  const [overrideBank, setOverrideBank] = useState(false);
  
  useEffect(() => {
    setVisible(silaModalVisible);
    if (silaModalVisible)
      fetchPlaidAccounts();
  }, [silaModalVisible]);

  const closeModal = () => {
    setVisible(false);
    closeSilaModal(false);
  }

  const fetchPlaidAccounts = async () => {
    try {
      setLoadingPlaidAccounts(true);
      const response = await API.getPlaidAccountDetails(userId);
      const activeAccounts = response.plaidConnections.filter(account =>
        account.accountState !== 'DELETED' && account.accountState !== 'REJECTED'
      );
      setPlaidAccounts(activeAccounts);
    } catch (ex) {
      message.error('Failed to fetch Plaid accounts');
    } finally {
      setLoadingPlaidAccounts(false);
    }
  }

  const chargeFromSilaAccount = async () => {
    if (!productId || !paymentProductType) {
      message.error('Card/product ID is missing');
      setVisible(false);
      closeSilaModal(false);
      return;
    }
    try {
      showModalLoading(true);
      await API.chargeFroSilaStripe(userId, productId, paymentProductType, selectedPlaidId);
      message.success('Successfully charged from the sila payment.');
      if (refreshList) refreshList();
    } catch (ex) {
      message.error(ex?.response?.data?.error_message);
      console.error(ex)
    }
    finally {
      setVisible(false);
      showModalLoading(false);
      closeSilaModal(false);
    }
  }

  const handlePlaidAccountChange = (value) => {
    setSelectedPlaidId(value);
  }

  const handleOverrideBankChange = (e) => {
    setOverrideBank(e.target.checked);
    if (!e.target.checked) {
      setSelectedPlaidId(null);
    }
  }

  return (
    <Modal
      title={'Charge From ACH'}
      centered
      mask={true}
      maskClosable={true}
      destroyOnClose={true}
      closable={true}
      open={visible}
      onOk={chargeFromSilaAccount}
      onCancel={closeModal}
      className="confirm-modal"
    >
      <>
        <p>
          Are you sure you want to retry the payment?
        </p>
        
        <Checkbox
          checked={overrideBank}
          onChange={handleOverrideBankChange}
          disabled={modalLoading}
        >
          Override default bank account
        </Checkbox>
        
        <div style={{ marginTop: 8 }}>
          <Select
            style={{ width: '100%', marginTop: 8 }}
            placeholder="Select override account"
            value={selectedPlaidId}
            onChange={handlePlaidAccountChange}
            loading={loadingPlaidAccounts}
            disabled={modalLoading || !overrideBank}
          >
            {plaidAccounts.map(account => (
              <Option key={account.id} value={account.id}>
                {account.bankName} (****{account.last4}) {account.isActive ? '(Primary)' : ''}
              </Option>
            ))}
          </Select>
        </div>
        
        <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginTop: 4 }}>
          If override is not selected, the primary bank account will be used by default.
        </Text>
        
        {modalLoading && <LoaderComponent />}
      </>
    </Modal>
  );
}

export default SilaPaymentModal;

